import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import LimaHeader, { LIMA_LOGO } from "../components/LimaHeader";
import { ShieldCheck, Gauge, FileCheck2, Sparkles, ArrowRight } from "lucide-react";

const bullets = [
  { icon: Gauge, title: "Motor adaptativo", desc: "As perguntas mudam com base nas atividades reais da empresa. Módulos NR-10/12/18/33/34/35 são ativados sob demanda." },
  { icon: ShieldCheck, title: "Matriz de exposição", desc: "Cada resposta gera nível de exposição, item por item, com apontamento da NR e da mitigação recomendada." },
  { icon: FileCheck2, title: "Faixa de risco de multa", desc: "Estimativa qualitativa (Baixo / Médio / Alto) da exposição a autuações, embargos e passivos." },
  { icon: Sparkles, title: "Sumário executivo por IA", desc: "Claude Sonnet 5 gera texto executivo e plano de mitigação priorizado, pronto para direção." },
];

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#f4f6f8]">
      <LimaHeader />
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 grid-bg opacity-70" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-10 py-16 md:py-24 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-7">
            <span className="inline-block text-[11px] tracking-[0.28em] font-bold text-[#c7a45a] mb-4">
              LIMA SST · MOTOR ADAPTATIVO
            </span>
            <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-[#10243f] leading-[1.05]">
              Diagnóstico inteligente de<br />
              <span className="text-[#c7a45a]">Segurança e Saúde</span> no Trabalho
            </h1>
            <p className="mt-6 text-lg text-slate-600 max-w-2xl">
              Descubra em minutos onde a sua empresa está exposta aos rigores da lei e
              qual o risco real de ser multada — com base nas NRs vigentes e nas atividades
              reais executadas.
            </p>
            <div className="mt-8 flex flex-wrap gap-4">
              <Link to="/checklist">
                <Button data-testid="cta-start-btn" className="bg-[#c7a45a] hover:bg-[#b58f43] text-[#10243f] font-bold px-7 py-6 text-base rounded-md">
                  Iniciar diagnóstico <ArrowRight className="ml-2" size={18} />
                </Button>
              </Link>
              <Link to="/login">
                <Button variant="outline" className="border-[#10243f] text-[#10243f] hover:bg-[#10243f] hover:text-white px-7 py-6 text-base rounded-md">
                  Já tenho conta
                </Button>
              </Link>
            </div>
          </div>
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-[#c7a45a]/20 to-transparent rounded-2xl blur-2xl" />
              <div className="relative bg-white border border-slate-200 rounded-2xl p-8 shadow-[0_20px_60px_-20px_rgba(16,36,63,0.25)]">
                <img src={LIMA_LOGO} alt="Lima SST" className="h-20 w-auto mb-6" />
                <div className="grid grid-cols-3 gap-3 text-center">
                  <div className="border border-slate-200 rounded-md p-3">
                    <div className="text-2xl font-display font-black text-[#10243f]">36</div>
                    <div className="text-[10px] uppercase tracking-widest text-slate-500">NRs cobertas</div>
                  </div>
                  <div className="border border-slate-200 rounded-md p-3">
                    <div className="text-2xl font-display font-black text-[#c7a45a]">AI</div>
                    <div className="text-[10px] uppercase tracking-widest text-slate-500">Claude Sonnet 5</div>
                  </div>
                  <div className="border border-slate-200 rounded-md p-3">
                    <div className="text-2xl font-display font-black text-[#10243f]">PDF</div>
                    <div className="text-[10px] uppercase tracking-widest text-slate-500">Relatório pronto</div>
                  </div>
                </div>
                <p className="mt-6 text-xs text-slate-500 italic">
                  "Protegendo pessoas. Fortalecendo empresas."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {bullets.map((b, i) => (
            <div key={i} className="bg-white border border-slate-200 rounded-xl p-6 hover:border-[#10243f]/30 transition-colors">
              <div className="w-11 h-11 rounded-md bg-[#10243f]/5 text-[#10243f] flex items-center justify-center mb-4">
                <b.icon size={22} />
              </div>
              <h3 className="font-display font-bold text-[#10243f] mb-2">{b.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{b.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <footer className="border-t border-slate-200 bg-white/50 py-8">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center text-xs text-slate-500">
          DIAGNÓSTICO LIMA SST · Instrumento de triagem e diagnóstico. Não constitui certificação ou garantia de inexistência de autuações.
        </div>
      </footer>
    </div>
  );
}
